import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import brain from '@/assets/images/brain-with-magnifying-glass.png';
import heart from '@/assets/images/heart-screams.png';
import { SectionHeadline } from '@/components/SectionHeadline';
import { ContentContainer } from '@/components/layout';
import { LINKS } from '@/constants/links';
import { mergeClasses } from '@/utils/style';
import { Link } from '@/components/links';
export function NothingFound() {
  const $ = _c(15);
  const {
    t
  } = useTranslation("whereToShop");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = mergeClasses("flex flex-row flex-wrap items-center justify-center pb-[17.25rem] md:flex-nowrap md:pb-0");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("nothingFound.title");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <SectionHeadline className="mb-4 text-lg md:whitespace-nowrap lg:text-2xl" anchorKey="nothingFound.title">{t1}</SectionHeadline>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Link to={LINKS().contact} analyticsParam="whereToShopNothingFoundContact" testId="whereToShopNothingFoundContact" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = <p className="text-center text-sm lg:mx-auto lg:max-w-[26rem] lg:text-base"><Trans t={t} i18nKey="nothingFound.description">{t3}</Trans></p>;
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <div className="max-w-full md:order-2 md:w-1/2">{t2}{t4}</div>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="absolute -bottom-6 left-4 z-20 w-[13rem] md:relative md:left-0 md:order-1 lg:w-[22.25rem]"><Image src={brain} alt="" width={355} /></div>;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="absolute right-[2.25rem] bottom-0 z-10 w-[10.25rem] md:relative md:right-0 md:order-3 lg:w-[17rem]"><Image src={heart} alt="" width={271} /></div>;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t5) {
    t8 = <ContentContainer><div className={t0}>{t5}{t6}{t7}</div></ContentContainer>;
    $[13] = t5;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}